export default "__VITE_ASSET__G5fhHFQN__"